import { actionRemoveInSceneItem, actionUpdateSceneItem } from '../../../../store/actions/user.actions';
import { Component, Injector } from '@angular/core';
import { BlockBaseComponent } from "../block-base/block-base.component";
import { AppService, LocalStoreService, StoreSelectorsService } from "../../../../services";
import { MatDialog } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { debounce } from "utils-decorators";
import { IPlayerService } from '@signage/lib';
import { Lib } from "../../../../../libs/Lib";
import { actionAddPaint, actionAddSceneItem, actionCRUDRecord, actionSceneSvgColor, actionUpdateResources } from '../../../../store/actions/user.actions';
import { IAppSettingsWrap, ICRUDCommand, ICRUDRecord, IPaintSource, IPlayerProps, IResource, IResourcePreview } from '../../../../interfaces';
import { DialogGetAssetComponent, IDialogGetAsset } from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import { getResourcePreview, RESOURCE_IMAGE_TYPES } from '../../../../common';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-scene-block-image',
    templateUrl: './block-image.component.html',
    styleUrls: ['./block-image.component.scss']
})
export class BlockImageComponent extends BlockBaseComponent {
    resource: IResource;
    resourcePreview: IResourcePreview;
    coreAppData: IAppSettingsWrap;
    isSVG = false;
    selectedFontColorFill = '#FFFFFF';
    selectedFontColorStroke = '#FFFFFF';
    fillWaitMode = false;
    strokeWaitMode = false;

    constructor(
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        private toastr: ToastrService,
        public override dialog: MatDialog,
        private router: Router,
        private appService: AppService,
        private injector: Injector,
        protected override localStoreService: LocalStoreService) {
        super(storeSelector, dialog);

        const playerService: IPlayerService = this.injector.get('playerService');
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );

        this.cod(
            this.storeSelector.getSvgColors().subscribe((v) => {
                this.selectedFontColorStroke = v.itemStrokeColor;
                this.selectedFontColorFill = v.itemFillColor;
            })
        );
        this.cod(
            playerService.studioChannel$
                .subscribe((v) => {
                    if (!this.isSVG || (!this.fillWaitMode && !this.strokeWaitMode)) return;
                    const event: any = v;
                    if (event) {
                        if (event.name == 'svg' && event.event == "select") {
                            if (this.fillWaitMode || this.strokeWaitMode) {
                                if (!this.sceneItem.Data[0].Resource[0].Svg?.[0]?.Item) {
                                    return this.addSvgColor(event.path);
                                }
                                const index = this.sceneItem.Data[0].Resource[0].Svg[0].Item.findIndex((s) => {
                                    return s.$.path === event.path;
                                });
                                if (index === -1) {
                                    this.appendSvgColor(event.path);
                                } else {
                                    this.replaceSvgColor(index);
                                }
                            }
                        }
                    }
                })
        );
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        this.cod(
            this.storeSelector.getResource(this.sceneItem.Data["0"].Resource["0"].$.resource)
            .pipe(take(1))
            .subscribe((v) => {
                if (v) {
                    this.resource = v;
                    this.resourcePreview = getResourcePreview(this.resource, this.coreAppData, false, -1, false);
                    this.isSVG = this.sceneItem.$.player === this.blockLabelRecords.SVG.id;
                }
            })
        )
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        if (this.sceneItem.$.player === this.blockLabelRecords.SVG.id) return this.uiConfigInit = [];
        this.uiConfigInit = [
            // {
            //     type: "input",
            //     value: 'resource',
            //     label: this.translocoService.translate('general.label', {}, this.translocoService.getActiveLang()),
            //     inputType: "text",
            //     name: "label",
            //     storePath: '$.label'
            // },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.maintainRatio', {}, this.translocoService.getActiveLang()),
                name: "maintain",
                storePath: 'Data[0].Resource[0].AspectRatio[0].$.maintain'
            }
        ];
        // this.uiConfigInit = this.appendGpu(this.uiConfigInit);
    }

    initColor() {
        this.storeSelector.dispatch(actionAddSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Svg',
                value: null,
                storePath: 'Data[0]',
                cloneValue: true,
                preProcessFunction: (sceneItemNewValues, draft, action, sceneTreeSlice) => {
                    sceneTreeSlice.sceneItem.Data[0].Resource[0].Svg = [];
                }
            }]
        }));
    }

    resetColorSvg() {
        this.initColor();
        this.fillWaitMode = false;
        this.strokeWaitMode = false;
        this.storeSelector.dispatch(actionAddSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Svg',
                value: null,
                storePath: 'Data[0]',
                cloneValue: true,
                preProcessFunction: (sceneItemNewValues, draft, action, sceneTreeSlice) => {
                    delete sceneTreeSlice.sceneItem.Data[0].Resource[0].Svg;
                }
            }]
        }));
    }

    private replaceSvgColor(index) {
        const mode = this.fillWaitMode ? 'fill' : 'stroke';
        const color = this.fillWaitMode ? this.selectedFontColorFill : this.selectedFontColorStroke;
        this.storeSelector.dispatch(actionAddSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Svg',
                value: null,
                storePath: 'Data[0]',
                cloneValue: true,
                preProcessFunction: (sceneItemNewValues, draft, action, sceneTreeSlice) => {
                    sceneTreeSlice.sceneItem.Data[0].Resource[0].Svg[0].Item[index].$[mode] = color;
                }
            }]
        }));
    }

    private addSvgColor(i_path) {
        const mode = this.fillWaitMode ? 'fill' : 'stroke';
        const color = this.fillWaitMode ? this.selectedFontColorFill : this.selectedFontColorStroke;
        this.storeSelector.dispatch(actionAddSceneItem({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                updatedItemIds: [this.sceneItem.$.id],
                values: [{
                    key: 'Svg',
                    cloneValue: false,
                    value: {
                        Item: [
                            {
                                $: {[mode]: color, path: i_path}
                            }]
                    },
                    storePath: 'Data[0].Resource[0]'
                }]
            })
        );
    }

    private appendSvgColor(i_path) {
        const mode = this.fillWaitMode ? 'fill' : 'stroke';
        const color = this.fillWaitMode ? this.selectedFontColorFill : this.selectedFontColorStroke;
        this.storeSelector.dispatch(actionAddSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            updatedItemIds: [this.sceneItem.$.id],
            values: [{
                key: 'Item',
                cloneValue: false,
                value:
                    {
                        $: {[mode]: color, path: i_path}

                    },
                storePath: 'Data[0].Resource[0].Svg[0]'
            }],
        }));
    }

    override submit(formValues) {
        super.submit(formValues);
    }

    @debounce(200)
    updateResourceProperty(event) {
        // if (!this.accessConfig.upd) return this.accessService.showNoAccess();
        if (!this.resource) {
            return;
        }
        this.crudResource('update',
            String(this.resource.resource_id), {
                access_key: this.resource.access_key,
                tree_path: this.resource.tree_path,
                resource_name: event.target.value
            });
        this.storeSelector.dispatch(actionUpdateResources({
            resourcesId: this.resource.resource_id,
            access_key: this.resource.access_key,
            tree_path: this.resource.tree_path,
            resource_name: event.target.value
        }));
    }

    private crudResource(command: ICRUDCommand, id, body) {
        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command,
                primary: 'resource_id',
                table: 'resources',
                body,
                id
            }
        }));
    }

    async eyeDropperFill() {
        try {
            // @ts-expect-error:
            const eyeDropper = new EyeDropper();
            const selectedColor = await eyeDropper.open();
            if (!selectedColor) return;
            const selected = Lib.EyeDropperConvert(selectedColor.sRGBHex);
            this.selectedFontColorFill = selectedColor.sRGBHex;
            // const onChangeDebounced('color');
        } catch (err) {
            console.log('color selection cancelled');
        }
    }

    async eyeDropperFillStroke() {
        try {
            // @ts-expect-error:
            const eyeDropper = new EyeDropper();
            const selectedColor = await eyeDropper.open();
            if (!selectedColor) return;
            const selected = Lib.EyeDropperConvert(selectedColor.sRGBHex);
            this.selectedFontColorStroke = selectedColor.sRGBHex;
            // const onChangeDebounced('color');
        } catch (err) {
            console.log('color selection cancelled');
        }
    }

    toggleFillWaitMode(on = null) {
        this.strokeWaitMode = false;
        this.fillWaitMode = on === true ? true : !this.fillWaitMode;
        if (this.fillWaitMode && !this.sceneItem.Data[0].Resource[0].Svg) {
            this.initColor();
        }
    }

    toggleStrokeWaitMode(on = null) {
        this.fillWaitMode = false;
        this.strokeWaitMode = on === true ? true : !this.strokeWaitMode;
        if (this.strokeWaitMode && !this.sceneItem.Data[0].Resource[0].Svg) {
            this.initColor();
        }
    }

    notifyColorSelected() {
        this.storeSelector.dispatch(actionSceneSvgColor({
            payload: {
                itemFillColor: this.selectedFontColorFill,
                itemStrokeColor: this.selectedFontColorStroke
            }
        }));
    }

    async onEditResource() {
        if (!this.resource.resource_id || !this.resourcePreview) return;
        this.localStoreService.setStorageValConfig('paintEnabled', '1');

        // this.getMeta("https://oregon-signage-resources.s3-us-west-2.amazonaws.com/business595375/resources/109.svg", (err, img) => {
        //     console.log(img.naturalWidth, img.naturalHeight);
        // });
        let imageW = 500;
        let imageH = 500;
        if (this.resourcePreview.url) {
            try {
                const img = await Lib.getMeta(this.resourcePreview.url);
                imageW = img['naturalWidth'];
                imageH = img['naturalHeight'];
            } catch {
                console.log("image size error");
            }
        }

        this.cod(
            this.storeSelector.getPaints().subscribe((i_paints) => {
                if (i_paints) {
                    const i_paint = i_paints.find((p) => p.resource_id === this.resource.resource_id);
                    if (i_paint) {
                        this.router.navigateByUrl(`/paint/edit/${i_paint.id}`);
                        return;
                    }
                }
                const newPainter = {
                    painter_name: this.resource.resource_name ? this.resource.resource_name : 'resource paint',
                    painter_data: null,
                    resource_id: this.resource.resource_id,
                    width: `${imageW}`,
                    height: `${imageH}`,
                    tree_path: '',
                    created_at: Math.round(new Date().getTime() / 1000) + '',
                    updated_at: Math.round(new Date().getTime() / 1000) + ''
                };

                /** Add new painter */
                const saveRecord: ICRUDRecord = {
                    studioId: this.localStoreService.getStorageConfig().studioId,
                    command: 'add',
                    primary: 'painter_id',
                    table: 'painters',
                    body: newPainter,
                    id: null
                };

                this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
                    /** important dont update store since server command failed **/
                    if (!i_crudReply.serverReply.status) return;

                    newPainter['id'] = String(i_crudReply.serverReply.id);

                    this.storeSelector.dispatch(actionAddPaint({
                        data: newPainter as IPaintSource
                    }));
                    this.router.navigateByUrl(`/paint/edit/${i_crudReply.serverReply.id}`);
                });
            })
        );
    }

    openAssociateDialog() {
        const data: IDialogGetAsset = { mode: "RESOURCE:IMAGES", multiSelect: false };
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((dialogGetAsset: IDialogGetAsset) => {
                    if (!dialogGetAsset || !this.resource) return;
                    let newResourceType = dialogGetAsset.sourceData.resource_type;

                    // check if new resource is video type
                    if (!newResourceType || !RESOURCE_IMAGE_TYPES.includes(newResourceType.toLocaleLowerCase())) {
                        this.toastr.warning(this.translocoService.translate('toast.invalidResource', {}, this.translocoService.getActiveLang()));
                        return;
                    }
                    this.swapResource(dialogGetAsset.selected, newResourceType.toLocaleLowerCase());
                })
        );
    }

    swapResource(newResourceId, newResourceType) {

        // check swappable resource type
        // const resourceType = this.resource.resource_type;
        // if (resourceType === 'svg' && newResourceType !== 'svg') {
        //     this.toastr.warning(this.translocoService.translate('toast.invalidResourceOnlySVG', {}, this.translocoService.getActiveLang()));
        //     return;
        // } else if (resourceType !== 'svg' && newResourceType === 'svg') {
        //     this.toastr.warning(this.translocoService.translate('toast.invalidResourceNoSVG', {}, this.translocoService.getActiveLang()));
        //     return;
        // }

        let playerProps: IPlayerProps;
        if (newResourceType === 'svg') {
            playerProps = this.storeSelector.blockLabels.SVG.template.$;
        } else {
            playerProps = this.storeSelector.blockLabels.IMAGE.template.$;
        }

        // update resource id
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            updatedItemIds: [this.sceneItem.$.id],
            values: [
                {
                    key: 'player',
                    cloneValue: false,
                    value: playerProps.player,
                    storePath: '$'
                },
                {
                    key: 'label',
                    cloneValue: false,
                    value: playerProps.label,
                    storePath: '$'
                },
                {
                    key: 'resource',
                    cloneValue: false,
                    value: newResourceId,
                    storePath: 'Data[0].Resource[0].$'
                }
            ]
        }));

        // reset background
        this.storeSelector.dispatch(actionRemoveInSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Background',
                value: null,
                storePath: 'Data[0]'
            }]
        })
    );
    }
}


